import React from 'react'
import { useEffect, useState } from 'react'
import { Table, Space, Button, Pagination, Input, Col, Row, Checkbox, Divider, Modal, Image } from 'antd'
import { isEmpty, size, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { CONFIG_URL, PAGE_SIZE, POSITION_INFO, ROLE, ROLES, getPage } from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../common'
import Create from './Create'
import Detail from './Detail'
import useWindowDimensions from '../../common/useWindowDimensions'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import useModal from 'src/helpers/modal/useModal'
import { formatCurrency } from 'src/helpers/functions'
import SameNumberDetail from 'src/common/components/SameNumberDetail'

const FulfillmentManagement = observer((props: any) => {
   const { t } = useTranslation()
   const UserStore = useStore('UserStore')
   const AuthStore = useStore('AuthStore')
   const DebtsStore = useStore('DebtsStore')
   const { data_getUserInfo } = AuthStore
   const [textSearch, set_textSearch] = useState('')
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isLoading, setIsLoading] = useState(false)
   const { height, width } = useWindowDimensions()
   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [visibleSampleNumber, setVisibleSampleNumber] = useState(false)
   const [itemSame, setItemSame] = useState(null)
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [status, setStatus] = useState(POSITION_INFO.ALL.id)
   const [item, setItem] = useState(null)
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const { confirm } = useModal()

   const { rows, offset, count } = UserStore.listFulfillment

   useEffect(() => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      // handleDebt()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch])

   const handleDebt = async () => {
      await DebtsStore.getTotalPriceDebt(ROLES.FULFILLMENT)
   }

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage)
         const params = { offset, ...param }
         // console.log('params', params)

         await UserStore.getFulfillment(params)
      } catch (error) {
         // console.log(error)
      } finally {
         setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      if (size(trim(textSearch)) > 0) {
         getListData(currentPage - 1, { ...fieldFilter, ...{ name: trim(textSearch) } })
      } else {
         getListData(currentPage - 1, { ...fieldFilter })
      }
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const clearDetailInfo = () => {
      setItem(null)
   }

   const setDetailInfo = (value: any) => {
      setItem(value)
   }

   const showDetail = (value: any) => {
      setDetailInfo(JSON.parse(JSON.stringify(value)))
      // console.log('showDetail; ', JSON.parse(JSON.stringify(value)))

      setTimeout(() => {
         setVisibleDetail(true)
      }, 500)
   }

   const handleEdit = () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      setVisibleDetail(false)
      clearDetailInfo()
   }

   const handleEditSame = () => {
      setVisibleSampleNumber(false)
      setItemSame(null)
   }

   const hideDetailSame = () => {
      setVisibleSampleNumber(false)
      setItemSame(null)
   }

   const clickDetailSameNumber = async (record: any) => {
      setItemSame(record)
      // await UserStore.getSameNumber(record)
      setVisibleSampleNumber(true)
   }

   const hideDetail = () => {
      setVisibleDetail(false)
      clearDetailInfo()
   }

   const showCreate = () => {
      setVisibleCreate(true)
   }

   const handleCreate = async () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      setVisibleCreate(false)
   }

   const handleCancel = () => {
      setVisibleCreate(false)
   }

   const handleDelete = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonxoabanghi),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await UserStore.deleteEmployees(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }

   const columns = [
      {
         title: t(GLOBAL_CLIENT.id),
         dataIndex: 'id',
         key: 'id',
         align: 'center' as 'center',
         width: 50
         // fixed: 'left',
         //  render: (value: string, record: any, index: number) =>
         //      (page-1) * PAGE_SIZE + index + 1,
      },
      {
         title: t(GLOBAL_CLIENT.fullname),
         dataIndex: 'name',
         key: 'name',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'avatar',
         width: 40,
         key: 'avatar',
         render: (value: any) => {
            return (
               <Image
                  style={{ objectFit: 'cover', borderRadius: 15, width: 30 }}
                  height={30}
                  preview={{
                     mask: null
                  }}
                  fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                  src={`${CONFIG_URL.IMAGE_URL + '/' + value}`}
               />
            )
         }
      },
      // {
      //    title: t(GLOBAL_CLIENT.phone),
      //    dataIndex: 'phoneNumber',
      //    width: 80,
      //    key: 'phoneNumber',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      // {
      //    title: t(GLOBAL_CLIENT.txtEmail),
      //    dataIndex: 'email',
      //    width: 100,
      //    key: 'email',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      {
         title: t(GLOBAL_CLIENT.sodutaikhoan),
         dataIndex: 'wallet',
         width: 100,
         key: 'wallet',
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value?.balance, true) + 'đ'}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.supporter),
         dataIndex: 'email',
         width: 100,
         key: 'email',
         render: (value: any) => {
            return <span className="txtMax2Line">{'Supporter'}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.numberItems),
         dataIndex: 'sampleNumber',
         width: 100,
         key: 'sampleNumber',
         render: (value: any, record: any) => {
            return (
               <span
                  onClick={() => clickDetailSameNumber(record)}
                  className="gx-link"
                  style={{ textDecoration: 'underline' }}
               >
                  {value}
               </span>
            )
         }
      },
      // {
      //    title: t(GLOBAL_CLIENT.bankName),
      //    dataIndex: 'bankName',
      //    width: 80,
      //    key: 'bankName',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      // {
      //    title: t(GLOBAL_CLIENT.accountBankName),
      //    dataIndex: 'accountBankName',
      //    width: 80,
      //    key: 'accountBankName',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      // {
      //    title: t(GLOBAL_CLIENT.bankAccount),
      //    dataIndex: 'bankNumber',
      //    width: 80,
      //    key: 'bankNumber',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      // {
      //    title: t(GLOBAL_CLIENT.note),
      //    dataIndex: 'note',
      //    key: 'note',
      //    width: 120,
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // },
      {
         title: t(GLOBAL_CLIENT.statusAccount),
         dataIndex: 'status',
         width: 80,
         key: 'status',
         render: (value: boolean) => {
            return (
               <Checkbox disabled defaultChecked={value}>
                  {t(value ? GLOBAL_CLIENT.active : GLOBAL_CLIENT.inactive)}
               </Checkbox>
            )
         }
      },
      {
         title: 'Action',
         key: 'action',
         width: 80,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (record: any) => {
            return (
               <span className="txtMax2Line">
                  <span onClick={() => showDetail(record)} className="gx-link ">
                     {t(GLOBAL_CLIENT.edit)}
                  </span>
                  {data_getUserInfo?.role !== ROLE.SUPPORTER && (
                     <>
                        <Divider type="vertical" />
                        <span onClick={() => handleDelete(record)} className="gx-link">
                           {t(GLOBAL_CLIENT.delete)}
                        </span>
                     </>
                  )}
               </span>
            )
         }
      }
   ]

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }
   const onChangeStatus = (key: string | number, e: any) => {
      // let notOrder = OrderStore.optionSearchOrderCustomer.status.includes(1) ? [1] : []
      // let placingData = OrderStore.optionSearchOrderCustomer.status.includes(2) ? [2] : []
      // let orderFinish = OrderStore.optionSearchOrderCustomer.status.includes(3) ? [3] : []
      // let soldOut = OrderStore.optionSearchOrderCustomer.status.includes(4) ? [4] : []
      let statusNow = 'active'
      switch (key) {
         case 'active':
            if (e.target.checked) {
               statusNow = 'active'
            } else {
               statusNow = ''
            }
            break
         case 'inactive':
            if (e.target.checked) {
               statusNow = 'inactive'
            } else {
               statusNow = ''
            }
            break
         default:
            if (e.target.checked) {
               statusNow = 'active'
            } else {
               statusNow = ''
            }
            break
      }
      // setStatusObj(statusNow)
      // let dataStatus = [...placingData, ...notOrder, ...orderFinish, ...soldOut]
      // OrderStore.setOptionSearchOrderCustomer({ status: dataStatus })

      // const statusResult = [
      //    ...statusNow.new,
      //    ...statusNow.doing,
      //    ...statusNow.review,
      //    ...statusNow.reject,
      //    ...statusNow.finish
      // ].toString()
      // // console.log('statusNow: ', statusNow, 'statusResult; ', statusResult)
      // setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusNow } })
   }
   return (
      <>
         <Loading isLoading={isLoading} />
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder={t(GLOBAL_CLIENT.search)} allowClear />
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />

                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                           {/* <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng tiền</span>
                              <span style={{ fontSize: 20, color: '#89AD88', fontWeight: 'bolder' }}>{`${formatCurrency(
                                 DebtsStore.totalDebtsCreator,
                                 true
                              )} VND`}</span>
                           </Button> */}
                        </Space>
                     </div>
                  </Col>
               </Row>

               <Space
                  className="total-items"
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
               >
                  <span>
                     {t(GLOBAL_CLIENT.totalItems)}: {count}
                  </span>
                  <div>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus('active', e)}
                     >
                        {'Hoạt động'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus('inactive', e)}
                     >
                        {'Ngừng hoạt động'}
                     </Checkbox>
                  </div>
               </Space>

               <Table
                  scroll={{ x: 1500, y: height - 280 }}
                  columns={columns}
                  dataSource={rows}
                  rowKey="id"
                  pagination={false}
               />

               {renderPagination()}
            </Col>
         </Row>
         {visibleCreate && <Create visible={visibleCreate} onOk={handleCreate} onCancel={handleCancel} />}
         {item && visibleDetail && (
            <Detail visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />
         )}
         {itemSame && visibleSampleNumber && (
            <SameNumberDetail
               visible={visibleSampleNumber}
               item={itemSame}
               onOk={handleEditSame}
               onCancel={hideDetailSame}
            />
         )}
      </>
   )
})

export default FulfillmentManagement
